module.exports = __webpack_public_path__ + "img/bg-court.c5c96b56.svg";